export const formatReal = (value: number | string) =>
  `R$ ${Number(value)
    .toFixed(2)
    .replace('.', ',')
    .replace(/(\d)(?=(\d{3})+\,)/g, '$1.')}`;

export const parseReal = (value: string): number => {
  if (!value || value === '') return 0;
  const cleaned = value.replace(/[^\d,]/g, '');
  const normalized = cleaned.replace(',', '.');
  return parseFloat(normalized) || 0;
};

export default formatReal;
